export default function GetTimeStamp(dateString) {
    const dateObj = new Date(dateString)
    return dateObj.getTime()
}

export function getDateString(timestamp) {
    const dateObj = new Date(timestamp)
    let day = dateObj.getDate();
    let month = dateObj.getMonth()+1;
    let year = dateObj.getFullYear();

    if (day < 10) {
        day = '0' + day;
    }
    
    if (month < 10) {
        month = `0${month}`;
    }
    
    return `${day}/${month}/${year}`

}
export function getTimeString(timestamp){
    const dateObj = new Date(timestamp)
    var h = dateObj.getHours();
    var min = dateObj.getMinutes();
    return `${addOneZero(h)}:${addOneZero(min)}`
}
export function getInputDateString(end_date){
    var ed = new Date(end_date);
        var d = ed.getDate();
        var m = ed.getMonth() + 1;
        var y = ed.getFullYear();
        var h = ed.getHours();
        var min = ed.getMinutes();
        return `${y}-${addOneZero(m)}-${addOneZero(d)}T${addOneZero(h)}:${addOneZero(min)}`;

}

function addOneZero(num){
    return num<=9 ? '0' + num : num ;
}
